import { get, isEqual, omit } from 'lodash/fp'
import { combineActions, handleActions } from 'redux-actions'
import { getActionTypes } from 'redux-axios-middleware'

import actions from '@/actions'
import { queryClient } from '@/core/utils/react-query/queryClient'
import mergeState from '@/core/utils/redux/mergeState'
import { validateData } from '@/core/utils/validateData'
import { UserCurrentSchema, usersQueries } from '@/http/api/users'

const initialState = {
  fetching: false,
  fetched: false,
  failed: false,
  fresh: false,
  data: {},
  account: {},
}

const [GET_REQUEST, GET_SUCCESS, GET_ERROR] = getActionTypes({
  type: actions.user.get,
})
const [EMAIL_PUT_REQUEST] = getActionTypes({
  type: actions.user.email.put,
})
const [, LOGOUT_SUCCESS] = getActionTypes({ type: actions.user.logout })

export const REQUEST_ACTIONS = [GET_REQUEST, EMAIL_PUT_REQUEST]

export const SUCCESS_ACTIONS = [GET_SUCCESS]

export const ERROR_ACTIONS = [GET_ERROR]

export default handleActions(
  {
    [LOGOUT_SUCCESS]: (state) => ({
      ...state,
      data: {},
    }),
    // @ts-expect-error TS(2339): Property 'options' does not exist on type 'Action<... Remove this comment to see the full error message
    [combineActions(...REQUEST_ACTIONS)]: (state, { options = {} }) => ({
      ...state,
      fetching: !options.ignoreResponse,
    }),
    [combineActions(...SUCCESS_ACTIONS)]: (state, { payload: { data } }) => {
      // populate the query client with the current user data to avoid re-fetching
      queryClient.setQueryData(
        usersQueries.usersCurrentDetails().queryKey,
        validateData(
          UserCurrentSchema,
          data,
          'Redux reducer for user current details',
        ),
      )

      return {
        ...state,
        data,
        fetching: false,
        fetched: true,
        fresh: true,
        failed: false,
      }
    },
    [combineActions(...ERROR_ACTIONS)]: (state, { error }) => ({
      ...state,
      data: {},
      fetching: false,
      failed: true,
      fresh: true,
      error: get('response.data.message', error),
    }),
    [actions.user.updateEmail]: (state, { payload }) =>
      mergeState(state, { data: { email: payload } }),
    [actions.user.updateAccount]: (state, { payload }) => {
      const fields = ['exp', 'iat', 'jti']
      const payloadWithoutPeriodicInfo = omit(fields, payload)
      const accountWithoutPeriodicInfo = omit(fields, state.account)

      // Do not update user in case only those three fields above changed (they change every 10 seconds or so).
      if (isEqual(accountWithoutPeriodicInfo, payloadWithoutPeriodicInfo)) {
        return state
      }

      queryClient.invalidateQueries(usersQueries.usersDetails())
      queryClient.invalidateQueries(usersQueries.usersCurrentDetails())
      return mergeState(state, { account: payload })
    },
  },
  initialState,
)
